import React from "react"
import { DataTable } from "home/components/data_table"

const EnemAnswerResultTablePresentation = ({ tableData, resource, hasFilters }) => (
  <DataTable tableData={tableData} resource={resource} hasFilters={hasFilters} tableSize="big" />
)

export default EnemAnswerResultTablePresentation
